// 德语 German
import deLocale from 'element-ui/lib/locale/lang/de'
const de = {
login:{
buttoo:{
    add:'add'
}
},
dialog:{
buttton:{
    close:'Schließen'
},
ReportError:{
   //未对应
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
 //未对应
},
},

Home:{
   //未对应
    Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
      SearchSanctions :"Search Sanctions",
    RiskScan:"Risk Scan",
    SearchRelationship :"Search Relationship",
    DataServices :"Data Services",
   //未对应

 selectCountry:'Land auswählen',
 inputCompany:"Firmennamen eingeben",
 keWord:'Stichwort',
 firstWord:"Text (Worte von links)",
 search:'Suchen',
 homeSeachTitle:'Globales Geschäft im Fokus',
 homeTitleDetail:"CSI, ein datenbasiertes Research- und IT-Unternehmen, ist auf Kredite, Risiken und Big Data spezialisiert. Es bietet globalen Investoren und Geschäftsleuten digitale Tools und nutzt fortschrittliche Analysen und Algorithmen, um schnelle, visuelle Einblicke zu liefern und so fundiertere Entscheidungen zu ermöglichen.",
 phoneTitleDetail:"Um schnell Unternehmensinformationen zu suchen, anzuzeigen und abzurufen, können Sie auch die CSI-App auf Ihrem Smartphone nutzen.",
 
 //未对应
   searchCompanyNum:"Suche nach über 500 Millionen Unternehmen in über 200 Ländern und Territorien",
 IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 
 //未对应
},
Toolbar:{
     Filter:"Filtern",
    Select:"Auswählen",
    Edit:"Bearbeiten",
    Sortby:"Sortieren nach",
    Collect:"Sammeln",
    Saved:"Gespeichert",
    Compare:"Vergleichen",
    Export:"Exportieren",
    Download:"Herunterladen",
    Update:"Aktualisieren",
    Reporterror:"Fehler melden",
    Share:"Teilen",
     //未对应
    ascending: "Ascending",
    descending: "Descending",
    Customfolder: "Custom folder",
     //未对应
},
AiZaba:{
   //未对应
whatareyousearchingfor: "What are you searching for?",
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
 //未对应
},
navigationBar:{
Notifications:'Benachrichtigungen',//通知
MarkasRead:'Als gelesen markieren',//标记已读
Viewall:'Alle anzeigen',//查看全部
SilverSubscriber:'Silber-Abonnent',//银级用户
Silversubscriberdate:'Ablaufdatum des Silber-Abonnements',//银级到期日
GoldSubscriber:'Gold-Abonnent',//金级用户
Goldsubscriptiondate:'Ablaufdatum des Gold-Abonnements',//金级到期日
AvailableCredits:'Verfügbare Credits',//可用积分
AddCredits:'Credits hinzufügen',//购买积分
IndivdualAccount:'Einzelkonto', //个人账号
GroupAccount:'Gruppenkonto', //集团账号
//未对应
OrdinaryUsers:"Ordinary users",
UserAccount: "User Account",
Roles: "Rollen", //角色
},
ListofResults:{
  Country:'Land',
  Industry:'Branche',
  CompanyType:'Unternehmensart',
  CompanySize:'Unternehmensgröße',
  CompanyStatus:'Unternehmensstatus',
  CompanyName:'Firmenname',
  CoType:'Firmenart',
  RegStatus:'Registrierungsstatus',
  StateProvince:'Bundesland/Provinz',
  CityCounty:'Stadt/Landkreis',
  DistrictCity:'Bezirk/Stadt',
  IncDate:'Gründungsdatum',
  LegalForm:'Rechtsform',
  CoID:'Firmen-ID',
  TaxNo:'Steuernummer',
  ListingInfo:'Eintragsdaten',
  Phone:'Telefon',
  Website:'Website',
  Email:'E-Mail',
  LegalPerson:'Juristische Person',
  PostCode:'Postleitzahl',
  ISIC:'ISIC',
  IndustryDescription:'Branchenbeschreibung',
  NACE:'NACE',
  NAICS:'NAICS',
  CreditRating:'Bonität',
  SolvencyIndex:'Solvenzindex',
  ProbabilityofDefault:'Ausfallwahrscheinlichkeit',
  NoofEmployees:'Anzahl der Mitarbeiter',
  Revenue:'Umsatz',
  TotalAsset:'Gesamtvermögen',
  NetProfit:'Nettogewinn',
  ROA:'ROA',
  ROE:'ROE',
  ShowMore:'Mehr anzeigen',
  //未对应
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page',
      Foundover:'Found over',
    results:'results',
    Remove:'Remove',
    Confirm:'Bestätigen',
    Rescan:'Rescan'
},
ContentTabs:{
    Background:"Hintergrund",
    BusinessActivities:"Geschäftstätigkeit",
    Performance:"Performance",
    Publications:"Publikationen",
    CreditOpinion:"Kreditgutachten",
    MarketAnalysis:"Marktanalyse",
    Snapshot:"Kurzfassung",
    Profile:"Profil",
    Ownership:"Eigentümerschaft",
    RelatedCompanies:"Verbundene Unternehmen",
    Management:"Management",
    Operations:"Geschäftstätigkeit",
    Locations:"Standorte",
    Industry:"Branche",
    ImportExport:"Import & Export",
    SupplyChain:"Lieferkette",
    FinancialHighlights:"Finanzielle Highlights",
    RatioAnalysis:"Kennzahlenanalyse",
    IndustryNorm:"Branchennorm",
    News:"News",
    Sanctions:"Sanktionen",
    IndustryStatistics:"Branchenstatistik",
    RatingAnalysis:"Ratinganalyse",
    CompetitiveAnalysis:"Wettbewerbsanalyse"
},
Snapshot:{
    CompanyDQIdesc1:'The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.',
    CompanyDQIdesc2:'The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.',
    CompanyDQIdesc3:'Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.',
    CountryDQIdesc1:'The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.',
    CountryDQIdesc2:'Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.',
  CompanyDQI:'Firmen-DQI',//公司数据质量指数 DQI
  CountryDQI:'Länder-DQI',//国家数据质量指数 DQI
  CompanyTitle:'Data Quality Index (DQI) by Company',
  CountryTitle:'Data Quality Index (DQI) by Country',
 //未对应以上

  Address:'Adresse',//地址
  CountyCity:'Landkreis/Stadt',//县/市
  ProvinceState:'Provinz/Bundesland',//省/州
  CountryRegion:'Land/Region',//国家/地区
  ZipCode:'Postleitzahl',//邮政编码
  Website:'Website',//网站
  Email:'E-Mail',//电邮
  Tel:'Tel.',//电话
  LastUpdate:'Letzte Aktualisierung',//最近更新
  DataSource:'Datenquelle',//数据来源
  LegalStatus:'Rechtsform',//法定状况
  CoID:'Firmen-ID',//公司ID
  CompanyType:'Firmentyp',//公司类型
  RegistrationDate:'Registrierungsdatum',//注册日期
  RegistrationStatus:'Registrierungsstatus',//注册状态
  Listed:'Börsennotiert',//上市信息
  CurrentOpperations:'Aktuelle Geschäftstätigkeit',//经营状况
  IndustryCode:'Branchencode',//行业代码
  BusinessActivities:'Geschäftstätigkeit',//主营业务
  NoofEmployees:'Anzahl der Mitarbeiter',//员工数量
  NoofShareholders:'Anzahl der Aktionäre',//股东数量
  Management:'Management',//管理状况
  Performance:'Leistung',//业绩表现
  Revenue:'Umsatz',//收入
  Assets:'Vermögen',//资产
  ProfitLoss:'Gewinn/Verlust',//利润
  Growth:'Wachstum',//公司增长
  Competitiveness:'Wettbewerbsfähigkeit',//竞争力
  CreditOpinion:'Kreditauskunft',//信用状况
  CreditRating:'Kreditrating',//信用评级
  CreditScore:'Kredit-Score',//信用评分
  ESGRating:'ESG-Rating',//ESG 评级
  Solvency:'Solvenz',//偿还能力
  Sanctions:'Sanktionen',//全球制裁
  CoName:"Firmenname",
   //未对应
   RegName:"Reg. Name"
},
Profile:{
  CompareCompanies:'Compare Companies',//未对应
  AddaCompany:'Add a Company',//未对应
  CompanyProfile:'Firmenprofil',//基本资料
  CompanyName:'Firmenname',//公司名称
  NativeName:'Originelle Firmenname',//当地名称
  CompanyID:'Firmen-ID',//公司 ID
  VATNumber:'Umsatzsteuer-Identifikationsnummer',//VAT号
  StockCode:'Aktiencode',//股票代码
  Listed:'Börsennotiert',//上市日期
  RegistrationDate:'Registrierungsdatum',//注册日期
  LegalForm:'Rechtsform',//公司性质
  CompanyType:'Unternehmensart',//公司类型
  LegalStatus:'Rechtsstatus',//注册状态
  Jurisdiction:'Gerichtsbarkeit',//司法管辖区
  RegisteredAddress:'Registrierte Adresse',//注册地址
  ProvinceState:'Provinz/Bundesland',//省/州
  CountryRegion:'Land/Region',//国家/地区
  ZipCode:'Postleitzahl',//邮政编码
  OperatingAddress:'Geschäftsadresse',//经营地址
  LastUpdate:'Letzte Aktualisierung',//最近更新
  DataSource:'Datenquelle',//数据来源
  History:'Historie',//历史记录
   //未对应
  RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',

  CountyCity:'Landkreis/Stadt'
},
Ownership:{
 UltimateBeneficiary:'Endbegünstigter',//最终受益人
  InvolvingIndividuals:'Personen',//涉及自然人股东
  InvolvingEnterprises:'Unternehmen',//涉及法人股东
  ShareholderLevel:'Gesellschafterebene',//股东层级x
  Name:'Name',//名称
  Country:'Land',//国家/地区
  Location:'Standort',//地点
  Type:'Art',//类型
  Shares:'Aktien',//股份
  Relation:'Verhältnis',//关系
   //未对应
  Individuals :'Individuals',//关系
  PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Gesamt',//相关公司总计
  Entities:'Unternehmen',//法人实体
  Countries:'Länder',//国家/地区
  Branches:'Niederlassungen',//分支机构
  RelatedComp:'Verbundene Unternehmen',//关联公司
  Name:'Name',//名称
  Country:'Land',//国家/地区
  Location:'Standort',//地点
  Type:'Art',//类型
  Relation:'Beziehung',//关系
   //未对应
  BranchOffices:'Branch Offices',
  Individuals:'Individuals',
},
Management:{
    Management:'Management',//管理层
    ContactInfo:'Kontaktinformationen',//联系人信息
    Countries:'Länder',//国家/地区
    Name:'Name',//名称
    Position:'Position',//职位
    Department:'Abteilung',//部门
    Country:'Land',//国家/地区
    ShareholderNot:'Aktionär oder nicht',//是否股东
    Relation:'Beziehungen',//关系
    Verification:'Verifizierung',//已验证
    Searchmoreemails:'Weitere E-Mails suchen',//搜索更多电邮
    Roles:'Rollen',//角色
    EducationLevel:'Bildungsniveau',//教育程度
    Phone:'Telefon',//电话
    Email:'E-Mail',//电邮
    Verified:'Verifiziert',//已验证
    Searchmore:'Weitere E-Mails anderer Unternehmen suchen',//搜索更多其他公司的电邮
  //未对应
    Pleaseentername:"Please enter name",
    PleaseenterWebsite:"Please enter Website",
    UserSelfVerification:"User Self Verification",
    Userverified:"User verified",
},
Operations:{
    Operations:'Operations',
    LineofBusiness:'Geschäftszweig',//业务范围
    BusinessTerritories:'Geschäftsgebiete',//业务区域
    ImportExport:'Import & Export',//进出口信息
    Viewtradeinfo:'Weitere Handelsinformationen anzeigen',//查看更多贸易信息
    ProductsServices:'Produkte/Dienstleistungen',//产品/服务
    Products:'Produkte',//产品
    ProductImage:'Produktbild',//产品图片
    ProductName:'Produktname',//产品名称
    ProductDescription:'Produktbeschreibung',//产品描述
    Details:'Details',//详情
    Addproductinformation :'Produktinformationen hinzufügen',//添加产品信息
    //未对应
    Showcaseyourcompany:"If you’d like to showcase your company’s products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published."
},
Locations:{
  Locations:"Locations",
  CoName:'Firmenname',//业务范围
  Relationship:'Beziehung',//关系
  Type:'Art',
  Country:'Land',//国家/地区
  Location:'Standort',//地点
  Address:'Adresse',//地址
  Edit:'Bearbeiten',//编辑
  CompanyLocatiionsMap:'Firmenstandorte auf Karte',//地图中的公司位置
  Selectaddresstype:'Adresstyp auswählen',//选择地址类型
  Subjectcompany:'Unternehmen',//目标公司
  Subsidiary:'Tochtergesellschaft',//子公司
  RegisteredAddress :'Eingetragene Adresse',//注册地址
  OperationAddress :'Betriebsadresse',//运营地址
  All :'Alle',//全部
  //未对应
  Showlocation :"Show location ",
},
Industry:{
  IndustryTitle:'Branchenbezeichnung',//IndustryTitle
  IndustryDescription:'Branchenbeschreibung',//IndustryDescription
  ISIC:'ISIC',//ISIC
  ISICDescription:'ISIC-Beschreibung',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'NACE-Beschreibung',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'NAICS-Beschreibung',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'CSIC-Beschreibung',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'AAAIC-Beschreibung',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'GICS-Beschreibung',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Gesamtimportmenge',//进口总额
  TopImportCountry:'Hauptimportland',//最大进口国家/地区
  TopImportProduct:'Hauptimportprodukt',//最大进口产品
  TotalExport:'Gesamtexport',//出口总额
  TopExportCountry:'Hauptexportland',//最大出口国家/地区
  TopExportProduct:'Hauptexportprodukt',//最大出口产品
  TradeVolume:'Handelsvolumen',//贸易额
  ImportShipments:'Importsendungen',//进口量
  ExportShipments:'Exportsendungen',//出口量
  ImportCountries:'Importländer',//进口国家/地区
  ExportCountries:'Exportländer',//出口国家/地区
  ImportVolume:'Importvolumen',//进口量
  ExportVolume:'Exportvolumen',//出口量
  TopSuppliers:'Hauptlieferanten',//主要供应商
  ByNumberofShipments:'Nach Anzahl der Sendungen',//按出货量
  TopBuyers:'Hauptkäufer',//主要买家
  ByNumberofShipments:'Nach Anzahl der Sendungen',//按出货量
  ImportQuantity:'Importmenge',//进口数量
  IncreaseDecreasexRate:'Zunahme-/Abnahmerate',//增/减率
  ExportQuantity:'Exportmenge',//出口数量
  ImportsExportsRecords:'Import- und Exportaufzeichnungen',//进出口记录
  Date:'Datum',//日期
  Product:'Produkt',//产品
  HSCode:'HS-Code',//HS 编码
  BuyerName:'Käufername',//买家名称
  Destination:'Bestimmungsort',//目的地
  SupplierName:'Lieferantname',//供应商名称
  Origin:'Herkunft',//原产地
  Amount:'Betrag',//金额
  Details:'Details',//详情
   //未对应
  Imports:'Imports',
  Exports:'Exports',
  Shipments:'Shipments',
  value:'value',
  ByNumberofvalue:'By Number of value',
  viewmoretradeinfo:'view more trade info',
  SearchHSCode:"Search HS Code",
},
SupplyChain:{
  //未对应
    Illustratesthesubjectcompany:"This chart illustrates the subject company’s “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
},
ShippingOrderDetails:{
    Date:"Datum",
    MasterBillofLading:"Master-Ladeschein",
    Source:"Quelle",
    BillNo:"Ladescheinnummer",
    ImporterBuyer:"Importeur/Käufer",
    ExporterSeller:"Exporteur/Verkäufer",
    Name:"Name",
    Address:"Adresse",
    Country:"Land",
    Contact:"Kontakt",
    Email:"E-Mail",
    CargoInfo:"Frachtinformationen",
    HSCode:"HS-Code",
    Quantity:"Menge",
    WeightUnit:"Gewichtseinheit",
    ProductDescription:"Produktbeschreibung",
    Amount:"Betrag",
    QuantityUnit:"Mengeneinheit",
    Weight:"Gewicht",
    HSDescription:"HS-Bezeichnung",
    Incoterms:"Incoterms",
    ShippingInfo:"Versandinformationen",
    Vessel:"Schiff",
    Consignee:"Empfänger",
    MeansofTransport:"Transportmittel",
    CountryofOrigin:"Ursprungsland",
    Voyage:"Reise",
    Notifier:"Melder",
    CountryofDestnation:"Bestimmungsland",
    AddressofOrigin:"Ursprungsadresse",
    Shipper:"Versender",
    AddressofDestnation:"Bestimmungsadresse",
    Container:"Container",
    ContainerID:"Container-ID",
    ContainerType:"Containertyp",
    ContainerDescDode:"Containerbeschreibung",
    ContainerSize:"Containergröße",
    ImportExport: "Importer / Exporter",//未对应
},
 FinancialHighlight:{
  Revenue:'Umsatz',//收入
  Profit:'Gewinn',//利润
  Growth:'Wachstum',//增长
  FinancialStructure:'Finanzstruktur',//融资结构
  CreditOpinion:'Kreditbewertung',//信用评估
  RiskIndicator :'Risikoindikator',//风险指标
  Solvencyindex:'Bonitätsindex',//偿还指数
  Year:'Jahr',//年份
  Change:'Veränderung',//变化
  NetProfit:"Nettogewinn",
  TotalAssets:"Bilanzsumme",
  Equity:"Eigenkapital",
  GrossMargin:"Bruttomarge",
  ProfitMargin:"Gewinnspanne",
  ReturnonEquity:"Eigenkapitalrendite",
  CurrentRatio:"Aktuelle Kennzahl",
  DebtRatio:"Verschuldungsgrad",
  FinancialHighlights:'Finanzdaten der verbundenen Unternehmen',//关联公司财务数据
  FinancialHighlightsTitle:'Finanzielle Highlights der verbundenen Unternehmen',//关联公司财务摘要
  CompanyName:'Firmenname',//公司名称
  CompanyID:'Firmen-ID',//公司ID
  Country:'Land',//国家/地区
  CompanyStatus:'Firmenstatus',//公司状态
  Relations:'Beziehungen',//关系
  Cancel:'Abbrechen',//取消
  Select:"Auswählen",
   //未对应
   Liquidity:'Liquidity',//现金流状况
  RatioAnalysis:'Kennzahlenanalyse der verbundenen Unternehmen', //关联公司比率分析
  Financialperformancedata:"Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:"When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    Byprovidingyou:"By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay:"Please Select The Year to Display",
    SelectUptoThreeYears:"Select Up to Three Years",
},
RatioAnalysis: {
    ProfitabilityRatios:'Rentabilitätskennzahlen',
    Year:'Jahr',
    Change:'Veränderung',
    Returnonequity :'Eigenkapitalrendite',
    Returnonassets:'Gesamtrendite',
    Profitmargin:'Gewinnspanne',
    Grossmargin:'Bruttomarge',
    OperatingRatios:'Betriebskennzahlen',
    Assetsturnover:'Kapitalumschlag',
    Stockturnover:'Lagerumschlag',
    Salesperiod:'Verkaufszeitraum',
    Collectionperiod:'Inkassozeitraum',
    Creditperiod:'Kreditlaufzeit',
    StructuralRatios:'Strukturkennzahlen',
    Currentratio:'Aktuelle Kennzahl',
    Quickratio:'Quick ratio',
    Shareholdersliquidityratio:'Liquiditätsquote',
    Solvencyratio:'Solvenzquote',
    Debtratio:'Verschuldungsgrad',
    ProductivityRatios:'Produktivitätskennzahlen',
    Profitperemployee:'Gewinn pro Mitarbeiter',
    Operatingrevenueperemployee:'Betriebsertrag pro Mitarbeiter',
    Shareholdersfundsperemployee:'Eigenkapital pro Mitarbeiter',
    Totalassetsperemployee:'Bilanzsumme pro Mitarbeiter',
    GrowthRatios:'Wachstumskennzahlen',
    Salesgrowthrate:'Umsatzwachstumsrate',
    Netprofitgrowthrate:'Nettogewinnwachstumsrate',
    Totalassetsgrowthrate:'Bilanzwachstumsrate',
    FinancialHighlights:'Finanzdaten der verbundenen Unternehmen',//关联公司财务数据
    RatioAnalysis:'Kennzahlenanalyse der verbundenen Unternehmen', //关联公司比率分析
    CompanyName:'Firmenname',
    CompanyID:'Firmen-ID',
    Country:'Land',
    CompanyStatus:'Firmenstatus',
    Relations:'Beziehungen'    
},
IndustryNorms:{
    IndustryStatistics:"Branchenstatistik",
    ofcompaniesintheIndustry:"Anzahl der Unternehmen in der Branche",
    oflistedCompaniesintheIndustry:"Anzahl der börsennotierten Unternehmen in der Branche",
    oflargecompaniesintheIndustry:"Anzahl der Großunternehmen in der Branche",
    ofSMEsintheIndustry:"Anzahl der KMU in der Branche",
    ofcompaniesinsample:"Anzahl der Unternehmen in der Stichprobe",
    ofcompaniesinloss:"Anzahl der Unternehmen mit Verlust",
    Observations:"Beobachtungen",
    AverageValue:"Durchschnittswert",
    MedianValue:"Medianwert",
    MaximumValue10:"Maximalwert 10 %",
    MinimumValue10:"Minimalwert 10 %",
    SubjectCompany:"Betroffenes Unternehmen",
    YearsinBusiness:"Geschäftsjahre",
    TotalAssets:"Bilanzsumme",
    TotalEquity:"Eigenkapital",
    Revenue:"Umsatz",
    NetEarning:"Nettogewinn",
    Returnonassets:"Kapitalrendite",
    Performance:"Leistung",
    ProfitabilityRatios:"Rentabilitätskennzahlen",
    Returnonequity:"Eigenkapitalrendite",
    Returnonassets:"Kapitalrendite",
    Grossmargin:"Bruttogewinnspanne",
    OperatingRatios:"Betriebskennzahlen",
    Stockturnover:"Lagerumschlag",
    Accountsreceivableturnover:"Debitorenumschlag",
    Assetsturnover:"Vermögensumschlag",
    Totalassetturnover:"Gesamtvermögensumschlag",
    StructuralRatios:"Strukturkennzahlen",
    Currentratio:"Aktuelle Kennzahl",
    Quickratio:"Quick ratio",
    Shareholdersliquidityratio:"Liquiditätsquote",
    GrowthRatios:"Wachstumskennzahlen",
    Salesgrowthrate:"Umsatzwachstumsrate",
    Netprofitgrowthrate:"Nettogewinnwachstumsrate",
    Totalassetsgrowthrate:"Bilanzwachstumsrate"
},
Lawsuits:{
  //未对应
    Lawsutis: "Lawsutis",
    Date: "Date",
    CaseCategory: "Case Category",
    Title: "Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Action",
},
 News:{
  Date:'Datum',//日期
  Title:'Titel',//标题
  Source:'Quelle',//来源
  Impact:'Auswirkung',//影响
  Searchcompanies:'Weitere Nachrichten zu anderen Unternehmen suchen',//国家/地区
  //未对应
  SearchforTitle:"Search for Title",
},
 Sanctions:{
  Potentialcompliance:'Es wurden potenzielle Compliance-Risiken erkannt.',//检测到潜在合规风险
  SeachbuttonNo:'Es wurden keine negativen Auswirkungen auf dieses Unternehmen festgestellt.',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'Um weitere Sanktionsaufzeichnungen zu suchen, klicken Sie bitte auf „Sanktionen suchen“.',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Sanktionen suchen',//搜索制裁
  ViewDetails:'Details anzeigen',//查看详情
  Sanctions:'Sanktionen',//制裁
  Potentialcompliancerisks:'Potenzielle Compliance-Risiken',//潜在合规风险
  IDInfo:'ID-Informationen',//ID 信息
  IDType:'ID-Typ',//ID 类型
  IDDescription:'ID-Beschreibung',//ID 描述
  SanctionList:'Sanktionsliste',//制裁名单
  SanctionListInvolved:'Betroffene Sanktionsliste',//涉及的制裁名单
  StartDate:'Startdatum',//生效日期
  EndDate:'Enddatum',//结束日期
  SourceList:'Quellenliste',//来源名单
  SourceName:'Quellenname',//来源名称
  ProfileNotes:'Profilnotizen',//主体资料
  Link:'Link',//链接
  Name:'Name',//名称
  //未对应
  AssociationList:"Association List",
    AssociationID:"Association ID",
    AssociationType:"Association Type",
},
CreditOpinion:{
    CreditAssessment:"Bonitätsprüfung",
    CreditAssessmentfromtheRelatedCompanies:"Bonitätsprüfung der verbundenen Unternehmen",
    Year:"Jahr",
    CreditRating:"Bonitätsrating",
    LocalCreditScore:"Lokale Bonitätsbewertung",
    ProbabilityofDefault:"Ausfallwahrscheinlichkeit",
    SolvencyIndex:"Bonitätsindex",
    CreditLine:"Kreditrahmen",
    RiskIndicator:"Risikoindikator",
    RelatedCreditAssessment:"Verwandte Bonitätsprüfung",
    CompanyName:"Firmenname",
    CompanyID:"Firmen-ID",
    Country:"Land",
    CompanyStatus:"Firmenstatus",
    Relations:"Beziehungen",
    Cancel:'Abbrechen',//取消
    Select:"Auswählen",
    //未对应
     LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
   CreditAssessmentMessage1:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability(Pd1Year)",
    Rating:"3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay:"Please Select The Year to Display",
    SelectUptoThreeYears:"Select Up to Three Years",
    //未对应
},
IndustryStatistics:{
    SubjectCompany:"Betreff Unternehmen",
    Country:"Land",
    Compare:"Vergleichen",
    Industry:"Branche",
    CompanyType:"Unternehmenstyp",
    CompanySize:"Unternehmensgröße",
    CompanyStatus:"Unternehmensstatus",
    YearsinBusiness:"Geschäftsdauer",
    CompanyRating:"Unternehmensbewertung",
      //未对应
    Liquidity:'Liquidity',
    NoofcoinIndustry:'No. of co. in Industry',
    IndustryRating:'Industry Rating',
    Profitability:'Profitability',
    Repaying:'Repaying',
    SearchCountry: "Search Country",
    //未对应
    Growth:'Wachstumskennzahlen',
    FinancialStructurt:'Finanzstruktur',
},
RatingAnalysis:{
    IndustyAnalysis:"Branchenanalyse",
    GeographicAnalysis:"Geografische Analyse",
    CompanyTypeAnalysis:"Unternehmenstypanalyse",
    BiusinessScaleAnalysis:"Skalenanalyse",
    HistoryAnalysis:"Historische Analyse",
    NormalDistribution:"Normalverteilung",
    SubjectCompany:"Unternehmen",
    Probabilityofthesubjectratinginitsindustry:"Wahrscheinlichkeit der Bewertung des Unternehmens in seiner Branche",
    Maximum:"Maximal 10 %",
    Mean:"Mittelwert",
    Average:"Durchschnitt",
    Minimum:"Minimum 10 %",
    RatingDistribution:"Bewertungsverteilung",
    Revenue:"Umsatz",
    Earning:"Ertrag",
    TotalAssets:"Bilanzsumme",
    Subjectratinginitsindustrybyfinancialindicators:"Bewertung des Unternehmens in seiner Branche nach Finanzkennzahlen",
    Best:"Beste",
    Worst:"Schlechteste",
    Rankingofsubject:"Ranking der Bewertung des Unternehmens in der Branche",
    Industy:"Branche",
    Percentilerank:"Perzentilrang: Prozentsatz der Unternehmen, die die Bewertung des Unternehmens erreicht oder unterschritten haben",
    Historicaldevelopmentofsubject:"Historische Entwicklung der Bewertung des Unternehmens in seiner Branche",
    IndustryAverage:"Branchendurchschnitt",
    SubjectRatingChanges:"Änderungen der Bewertung des Unternehmens",
    CompanySize:'Unternehmensgröße',
    YearsinBusiness:"Geschäftsjahre",
    //未对应
    CreditScore:"Credit Score",
    NOofCompanies:"NO. of Companies",
    ofCompanies:"% of Companies",
    CreditRating:"Credit Rating",
    SubjectsIndustryConcentrationAnalysis:"Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:"Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:"Geographic distribution in Subject's industry：",
    RatingDistributioninSubjectsLocation:"Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:"Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:"Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:"Rating ranking of companies with same history",
    Ratingstatistics:"Rating statistics of companies with the same years in business",
    Subjectratingcomparing:"Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup:"Subject rating in its group:",
    Analysisbasedonnature:"Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:"Subject rating position in its company type:",
    Ratingstatisticsofcompanies:"Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:"Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:"Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:"Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:"Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:"Rating statistics of companies in the same size and same industry",
    Rank:"Rank",
    Rating:"Rating",
},
CompetitiveAnalysis:{
    MarketPosition:"Marktposition",
    Revenus:"Umsatz",
    NetEarnings:"Nettogewinn",
    NetAssets:"Nettovermögen",
    TotalAssets:"Gesamtvermögen",
    Employees:"Mitarbeiter",
    Mean:"Mittelwert",
    Average:"Durchschnitt",
    Maximum:"Maximum (10 %)",
    Worst:"Schlechtestes (10 %)",
    Subjectcompany:"Vergleichsunternehmen",
    PerformanceComparison:"Leistungsvergleich",
    ProfitabilityRatios:"Rentabilitätskennzahlen",
    Grossmargin:"Bruttomarge",
    Returnonassets:"Kapitalrendite",
    Returnonequity:"Eigenkapitalrendite",
    OperatingRatios:"Betriebskennzahlen",
    Stockturnover:"Lagerumschlag",
    Assetsturnover:"Kapitalumschlag",
    Collectionperiod:"Erfassungszeitraum",
    GrowthRatios:"Wachstumskennzahlen",
    Totalassetsgrowthrate:"Wachstumsrate des Gesamtvermögens",
    Salesgrowthrate:"Umsatzwachstumsrate",
    Netprofitgrowthrate:"Wachstumsrate des Nettogewinns",
    StructuralRatios:"Strukturkennzahlen",
    Debtratio:"Verschuldungsgrad",
    Quickratio:"Quick ratio",
    Currentratio:"Aktuelle Kennzahl"
},
AccountCenterMenu:{
  SearchinSettings:"Suche in den Einstellungen",//在“设置”中搜索
  Account:"Konto",//账户
  MyAccount :"Mein Konto",//我的账户
  ContactInfo:"Kontaktdaten",//联系信息
  AccountSecurity:"Kontosicherheit",//账户安全
  OrganizationalManagement:"Organisationsverwaltung",//组织管理
  UserGroup:"Benutzergruppe",//用户组
  User:"Benutzergruppe",//用户
  Role:"Rolle",//角色
  MyDatabase:"Meine Datenbank",//我的数据库
  MyUsage:"Meine Nutzung",//我的使用情况
  CompaniesViewed:"Angesehene Unternehmen",//查看过的公司
  ReportsDownloaded:"Heruntergeladene Berichte",//下载的报告
  ReportUpdatesOrdered:"Bestellte Berichtsaktualisierungen",//订购的报告更新
  BillingandPayment:"Rechnungsdatensätze",//账单和付款
  BillRecords:"Rechnungsdatensätze",//账单记录
  PaymentRecords:"Zahlungsdatensätze",//付款记录
  CreditDeductions:"Gutschriften",//信用扣款
  InvoicesDownloaded:"Heruntergeladene Rechnungen",//下载的发票
  UserSettings:"Benutzereinstellungen",//用户设置
  Messages:"Nachrichten",//消息
  Notifications:"Benachrichtigungen",//通知
  HelpCenter:"Hilfe",//帮助中心
  FAQ:"FAQ",//常见问题
  Privacy:"Datenschutz",//隐私
  Terms:"Nutzungsbedingungen",//条款
  ReportIssues:"Probleme melden",//报告问题
  UserGuide:"Benutzerhandbuch",//用户指南
  AboutCSI:"Über CSI"//关于CSI
},
MyAccount:{
  Logintime:'Anmeldezeit',//登录时间
  SignOut:'Abmelden',//退出
  DeleteAccount:'Konto löschen',//删除账户
  AccountID:'Konto-ID',//账户ID
  Enteranewaddress:'Neue E-Mail-Adresse eingeben',//输入新的电邮
  EnterVerificationCode:'Bestätigungscode eingeben',//输入验证码
  SendverificationCode:'Bestätigungscode senden',//发送验证码
  Password:'Passwort',//密码
  Originalpassword:'Ursprüngliches Passwort',//原始密码
  Newpassword:'Neues Passwort',//新密码
  Confirmnewpassword:'Neues Passwort bestätigen',//确认新密码
  AccountOwnership:'Kontoinhaber',//账户所有权
  IndividualAccount:'Einzelkonto',//个人账户
  GroupAccount:'Gruppenkonto',//集团账户
  Organizationname:'Name der Organisation',//机构名称
  CountryRegion:'Land/Region',//国家/地区
  Address:'Adresse',//地址
  City:'Ort',//城市
  ZipCode:'Postleitzahl',//邮政编码
  FirstName:'Vorname',//名字
  LastName:'Nachname',//姓氏
  PhoneNumber:'Telefonnummer',//电话号码
  Email:'E-Mail',//更改
  Change:'Ändern',//更改
  Save:'Speichern',//保存
  Cancel:'Abbrechen',//取消
  LastLogin:'Letzte Anmeldung',//Last Login
  RecentLogin:'Letzte Anmeldung',//登录尝试次数
  AverageLoginTime:'Durchschnittliche Anmeldezeit',//平均登录时间
  TotalLoginAttempts:'Anmeldeversuche gesamt',//登录尝试次数

  //未对应
  Registrationtime:"Registration time",
  Role: "Rolle",
  Administrator:"Administrator",
  Enterpriseusers:"Enterprise users",
  EditImage:"Edit Image",
  DeleteImage:"Delete Image",

},
ContactInfo:{
    ContactInfo:"Kontaktinformationen",
    FirstName:"Vorname",
    LastName:"Nachname",
    PhoneNumber:"Telefonnummer",
    Email:"E-Mail",
    CountryRegion:"Land/Region",
    AddressLine:"Adresszeile",
    City:"Ort",
    ZipCode:"Postleitzahl",
    Alternativecontactperson:"Alternativer Ansprechpartner",
    Setascontactperson:"Als Ansprechpartner festlegen",
    Edit:"Bearbeiten"
},
AccountSecurity:{
    Setupmysecurityquestions:"Sicherheitsfragen einrichten",
    Pleasechooseaquestion:"Bitte wählen Sie eine Frage aus",
    Pleaseentertheanswertothequestion:"Bitte geben Sie die Antwort auf die Frage ein",
    SessionTimeoutAutomaticLogoutSettings:"Sitzungs-Timeout: Automatische Abmeldung",
    Thesystemwillautomatically:"Das System meldet Sie nach einer gewissen Zeit der Inaktivität automatisch ab. Die Standard-Timeout-Dauer beträgt 5 Minuten, Sie können diese jedoch nach Bedarf anpassen."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Gesamtzahl der gesuchten Unternehmen",
    TotalNumberofCompaniesCollected:"Gesamtzahl der erfassten Unternehmen",
    TotalNumberofUpdateReportsOrdered:"Gesamtzahl der bestellten Update-Berichte",
    Date:"Datum",
    UserName:"Benutzername",
    CompanyName:"Firmenname",
    Status:"Status",
    UsageType:"Nutzungsart",
    Entercompanyname:"Firmenname eingeben",
    Download:"Herunterladen"
},
OrganizationalManagement:{
    GroupName:"Gruppenname",
    ParentGroupName:"Name der übergeordneten Gruppe",
    Organization:"Organisation",
    GroupID:"Gruppen-ID",
    GroupStatus:"Gruppenstatus",
    Operation:"Operation",
    NewlyBuilt:"Neu erstellt",
    UserAccount:"Benutzerkonto",
    Role:"Rolle",
    AccountStatus:"Kontostatus",
    RoleName:"Rollenname",
    Position:"Position",
    RoleStatus:"Rollenstatus",
    Valid:"Gültig",
    Invalid:"Ungültig",
    PermissionSettings:"Berechtigungseinstellungen",
    ShowMore: "Show More",
    Search:'Suchen',
    Cancel:'Abbrechen',
    //未对应
    Confirm:'Bestätigen',
    NewGroup:"New Group",
    EnterGroupName:"Enter Group Name",
    NumberofGroups:"Number of Groups",
    Groups:"Groups",
    Roles: "Rollen",
    NewRoles:"New Roles",
    EnterNewRole:"Enter New Role",
    Users:"Users",
    EnterUserName:"Enter User Name",
},
BillingandPayment:{
    TotalNumberofOrders:"Gesamtzahl der Bestellungen",
    TotalPaymentAmount:"Gesamtzahlungsbetrag",
    TotalDeductionCredits:"Gesamtabzugsgutschriften",
    Date:"Datum",
    UserAccount:"Benutzerkonto",
    CompanyName:"Firmenname",
    OrderNo:"Bestellnummer",
    OrderType:"Bestellart",
    OrderStatus:"Bestellstatus",
    Download:"Herunterladen",
    PaymentAmount:"Zahlungsbetrag",
    Contactus:"Kontakt",
    DownloadInvoice:"Rechnung herunterladen",
    CreditsDeducted:"Abgezogene Gutschriften",
    ReportOrderStatus:"Bestellstatus melden",
    CompanyID:"Firmennummer",
    CountryRegion:"Land/Region",
    AddressLine:"Adresszeile",
    City:"Ort",
    ZipCode:"Postleitzahl",
    FirstName:"Vorname",
    LastName:"Nachname",
    PhoneNumber:"Telefonnummer",
    Email:"E-Mail",
    BankAccountHolderName:"Kontoinhaber",
    BeneficiaryBankName:"Name der Empfängerbank",
    SWIFTCODE:"SWIFT-CODE",
    AccountNumber:"Kontonummer",
    BeneficiaryBankAddress:"Adresse der Empfängerbank",
    ABA:"ABA (Bankleitzahl)",
    IBANnumber:"IBAN-Nummer",
    //未对应
    StartingMonth:"Starting Month",
    EndMonth:"End Month",
},
UserSettings:{
    LanguageandLocation:"Sprache und Standort",
    Language:"Sprache",
    Selectyourpreferedlanguage:"Wählen Sie Ihre bevorzugte Sprache",
    Location:"Standort",
    Selectyourlocation:"Wählen Sie Ihren Standort",
    NotificationSetting:"Benachrichtigungseinstellungen",
    EmailNotification:"E-Mail-Benachrichtigung",
    ServiceUpdates:"Service-Updates",
    CompanyNews:"Unternehmensnachrichten"
},
AddCredit: {
  //未对应
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining",
    Points: "points",
    Usermonth: "user/ month",
    Useryear: "user/ year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes:",
    EverythinginSilverPackage: "Everything in Silver package, plus:",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings:",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Company news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod:"Payment Method",
    CreditCardNumber:"Credit Card Number",
    EnterCardNumber:"Enter Card Number",
    ExpirationDate:"Expiration Date",
    Fullnameoncard:"Full name on card",
    EnterFullname:"Enter Full name",
    EnterProvinceState:"Enter Province / State",
    CVCCode:"CVC Code",
    EnterCVCCode:"Enter CVC Code",
    IncorrectCreditCardNumberformat :"Incorrect Credit Card Number format ",
    IncorrectExpMonthformat:"Incorrect Exp.Month format",
    IncorrectExpYearformat:"Incorrect Exp.Year format",
    IncorrectFullNameformat:"Incorrect Full Name format",
    IncorrectCountryformat:"Incorrect Country format",
    IncorrectProvinceStateformat:"Incorrect Province / State format",
    IncorrectCVCCodeformat:"Incorrect CVC Code format",
    TotalPurchase:"Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2:"CSI Services Agreement and Privacy .",
    Submit:"Submit",
    Month:"Month",

    Year: "Jahr", 
    Country: "Land",
    ProvinceState: "Provinz/Bundesland",
    Cancel: "Abbrechen",
  },
ReportIssues:{
    Whattypeoferrorsyouarereporting:"Welche Art von Fehlern melden Sie?",
    Tellusmoreaboutyourproblems:"Erzählen Sie uns mehr über Ihre Probleme.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Möchten Sie einen Screenshot oder eine Datei zu Ihrem Problem bereitstellen?",
    Fillinyourcontactinformation:"Geben Sie Ihre Kontaktdaten ein:",
    FirstName:"Vorname",
    LastName:"Nachname",
    PhoneNumber:"Telefonnummer",
    Email:"E-Mail",
    Edit:'Bearbeiten',
},
//Risk Scan
RiskScan:{
  RiskScan:"Risk Scan",
  RiskScanInfo:" ist Ihre Komplettlösung für umfassende Unternehmensrisikoanalysen. Wir bieten detaillierte Analysen aller wichtigen Risikokategorien, um Ihre Geschäftsentscheidungen abzusichern.",
  LegalRisk:"Rechtliches Risiko",
  LegalRiskInfo:"Überprüfen Sie die Legitimität des Unternehmens.",
  OrganizationalRisk:"Organisatorisches Risiko",
  OrganizationalRiskInfo:"Managementstabilität, Komplexität der Unternehmensstruktur und Transparenz der Eigentumsverhältnisse.",
  OperationalRisk:"Operatives Risiko",
  OperationalRiskInfo:"Schwachstellen in der Lieferkette, operativer Status und geopolitische Gefährdung.",
  FinancialRisk:"Finanzielle Leistungsrisiken",
  FinancialPerformanceRiskInfo:"Rentabilitätstrends, Liquiditätsprobleme und Bilanzgesundheit.",
  CreditRisk:"Kreditrisiko",
  CreditRiskInfo:"Kreditwürdigkeit, Zahlungshistorie und Ausfallwahrscheinlichkeit.",
  ComplianceRisk:"Compliance-Risiko",
  ComplianceRiskInfo:"Einhaltung von Sanktionen, Geldwäschebestimmungen und branchenspezifischen Gesetzen.",
  SustainabilityRisk:"Nachhaltigkeitsrisiko",
  SustainabilityRiskInfo:"ESG-Faktoren (Umwelt, Soziales, Unternehmensführung) und Reputationsauswirkungen.",
  IndustryRisk:"Branchenrisiko",
  IndustryRiskInfo:"Bewertet die Stabilität und die Zukunftsaussichten des gesamten Sektors eines Unternehmens.",
  LetBegin:"Los geht's",
  AddcompaniesfromSearchResult:"Unternehmen aus den Suchergebnissen hinzufügen",
  AddcompaniesfromMyDatabase:"Unternehmen aus meiner Datenbank hinzufügen",
  Addcompaniesbyuploadmyownlist:"Unternehmen hinzufügen, indem Sie Ihre eigene Liste hochladen",
  Cancel:'Abbrechen',
  Confirm:'Bestätigen',
  UploadFiles:"Dateien hochladen",
  PleaseuploadyourfileinCVSformat:"Bitte laden Sie Ihre Datei im xlsx-Format hoch.",
  Downloadxlsxtemplate:"xlsx-Vorlage herunterladen",
  Xcompanieswereuploadedsucessfuly:"Unternehmen wurden erfolgreich hochgeladen.",
  Xcompanieswereidentifiedsucessfuly:"Unternehmen wurden erfolgreich identifiziert.",
  Xcompanieswerenotmatched:"Unternehmen wurden nicht zugeordnet.",
  Uploadingfilefailed:"Datei konnte nicht hochgeladen werden. Bitte verwenden Sie die Vorlage und versuchen Sie es erneut.",
  ALL:"Alle",
  SearchLeads:"Interessenten suchen",
  LastUpdate:"Letzte Aktualisierung",
  CompanyID:"Firmen-ID",
  CompanyType:"Unternehmensart",
  RegistrationDate:"Registrierungsdatum",
  RegistrationStatus:"Registrierungsstatus",
  Listed:"an der Börse notiert",
  LegalStatus:"Rechtsstatus",
  NoofShareholders:"Anzahl der Aktionäre",
  ShareholdingLayers:"Aktionärsniveau",
  NoofCorporateShareholders:"Anzahl der institutionellen Aktionäre",
  NoofNatualPersonShareholders:"Anzahl der natürlichen Aktionäre",
  RelatedCompanies:"Verwandte Unternehmen",
  OrganizationalStatus:"Organisationsstatus",
  OperatingAddress:"Betriebsadresse",
  IndustryCode:"Branchenkodex",
  BusinessActivities:"Geschäftstätigkeit",
  NoofEmployees:"Anzahl der Mitarbeiter",
  Management:"Management",
  CurrentOperations:"Aktueller Betrieb",
  Revenue:"Umsatz",
  Assests:"Vermögenswerte",
  ProfitLoss:"Gewinn/Verlust",
  Liquidity:"Liquidität",
  Growth:"Wachstum",
  Performance:"Betriebsleistung",
  CreditRating:"Kredit rating",
  CreditScore:"Kreditwürdigkeit",
  PausibilityofDefault:"Ausfallwahrscheinlichkeit (PD)",
  SolvencyIndex:"Solvenzindex",
  DebtCollection:"Inkasso",
  CreditOpinion:"Kreditbeurteilung",
  CompanySanction:"Unternehmenssanktions",
  ProductSanction:"Produktsanktion",
  ExportControl:"Exportkontrolle",
  AntiCorruptionAntiBribery:"Korruptions und Bestechungsbekämpfung",
  Litigations:"Rechtsstreitigkeiten",
  NegativeNews:"Negative Nachrichten",
  ESGScore:"ESG-Score",
  YearsinBusiness:"Jahre im Geschäft",
  Competitiveness:"Wettbewerbsfähigkeit",
  WorkingCapital:"Marktrisiko",
  FinancialStructure:"Lieferkettenindex",
  Industrystatus:"Branchenstatus",
  IndustryOutlook:"Branchenausblick",
  NoofCompanies:"Anzahl der Unternehmen",
  IndustryRanking:"Branchenranking",
  IndustryConcentration:"Branchen-BIP %",
  IndustryCompetitiveness:"Industry Competitiveness",//未对应
  IndustryDevelopment:"Industry Development",//未对应
  CompanyName:"Name der Firma",
  Legal:"Rechtliches",
  Organizational:"Organisatorisches",
  Operational:"Operatives",
  Financial:"Finanzielle",
  Credit:"Kreditrisiko",
  Compliance:"Compliance",
  Sustainability:"Nachhaltigkeitsrisiko",
  Industry:"Branchenrisiko",
  Download:"Herunterladen",
  StartDate: "Startdatum", 
  EndDate: "Enddatum",
  Entercompanyname: "Firmenname eingeben",
  Tryagain:"Versuchen Sie es erneut",
  //未对应
  Uploadyourlistofcompanies:"Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
  Choose:"Choose",
  Upload:"Upload",
  Uploading:"Uploading",
  Uploadwithamaximumfilesizeof1M:"（Upload up to 100 pieces of data at a time, with a maximum file size of 1M）",
  Theuploadedonlyxlsx:"The uploaded file can only be in xls/xlsx format",
  RiskScanning:"Risk Scanning",
  Youhaveselectedatotalof:"You have selected a total of",
  Tostartriskscanning:"companies, click “confirm” to start risk scanning",
  Datascanningisinprogress:"Data scanning is in progress ...",
  ClearAll:'Clear All',
  SelectUpdateDate:"Select Last Update",
  UpdateStatus:"Update Status",
  Updated:"Updated",
  Notupdated:"Not updated",
  Updating:"Updating",
  SelectRiskValue:"Select Risk Value",
  ReSelectData:"Re Select Data",
  HistoricalData:"Historical Data",
  DiagnosticReport:"Diagnostic Report",
  Good:"Good",
  General:"General",
  Differ:"Differ",
  NotEvaluated:"Not Evaluated",
  ScanTime:"Scan Time",
  Rescan: "Rescan",
},
//Data Management
DataManagement:{
  DataManagement:"Datenverwaltung",
  AllCompanies:"Alle Unternehmen",
  CompaniesViewed:"Angesehene Unternehmen",
  CompaniesCollected:"Gesammelte Unternehmen",
  CompaniesUploaded:"Hochgeladene Unternehmen",
  MyPortfolio:"Mein Portfolio",
  Date:"Datum",
  CompanyName:"Name der Firma",
  Country:"Land",
  CompanyType:"Unternehmensart",
  CompanyStatus:"Unternehmensstatus",
  DQI:"DQI",
  Download:"Herunterladen",
  Addcompanies:"Unternehmen hinzufügen",
  Filter: "Filtern",
  Selectcountry:"Land auswählen",
  Selectindustry:"Branche auswählen",
  Selectcompanytype:"Firmentyp auswählen",
  Selectcompanysize:"Unternehmensgröße auswählen",
  Selectcompanystatus:"Seleccionar el estado de la empresa",
  Selectlistedcompanies:"Ausgewählte gelistete Unternehmen",
  Selectcompanyyearsinbusiness:"Wählen Sie die Jahre der Firmengründung",
  Industry:"Industrie",
  CompanySize:"Unternehmensgröße",
  Listed:"Börsennotierte",
  CompanyAge:"Unternehmensalter",
  SelectYear:"Jahr auswählen",
  SelectQuarter:"Wählen Sie ein Quartal aus.",
  SelectMonth:"Monat auswählen",
  Reset:"Zurücksetzen",
  Search:"Suchen",
  MyDatabase:"Meine Datenbank",
  CountriesLocated:"etablierte Länder",
  YearsinBusiness:"Jahre im Geschäft",
  CompanyDQI:"DQI",
  RiskScan:"Risikoanalyse",
  CreditAssessment:"Kreditbewertung",
  Uptodate:"Aktuell",
  Average:"Durchschnitt",
  Insufficient:"Unzureichend",
  Good:"Gut",
  Caution:"Vorsicht",
  Unknown:"Unbekannt",
  CompanyTag:"Firmenkennzeichen",
  Remove:"Entfernen",
  Uploaded:"Hochgeladen",
  Identified:"Identifiziert",
  Notmatched:"Nicht zugeordnet",
  Uploadfiles:"Dateien hochladen",
  Identifythecompanywithmanualcheck:"Identifizieren Sie das Unternehmen mit manueller Prüfung",
  Identifyacompanymanually:"Manuelle Identifizierung eines Unternehmens",
  Pleaseprovideanyrelevantinformation:"Bitte geben Sie alle relevanten Informationen an, die die Suchergebnisse verbessern könnten. Unser Datenanalyst wird Sie mit dem am besten geeigneten Unternehmen zusammenbringen.",
  RegistrationID:"Unternehmens-ID",
  StateProvince:"Bundesland/Provinz",
  Address:"Adresse",
  Otherinformation:"Weitere Informationen",
  Submit:"Einreichen",
  Cancel: "Stornieren",
  Confirm:"Bestätigen",
  PortolioName:"Portfolio-Name",
  User:"Benutzer",
  Task:"Aufgabe",
  NoofCompanies:"Anzahl der Unternehmen",
  Entercompanyname:"Firmennamen eingeben",
  SaveYourPortfolio:"Speichern Sie Ihr Portfolio",
  PortfolioName:"Portfolio-Name",
  Notes:"Anmerkungen",

  //未对应
  Rescan:"Rescan",
  Match:"Match",
  Delete:"Delete",
  Edit:"Edit",
  AllData:"All Data",
  CountriesLocated:"Countries Located",
  EnterRegistrationID:"Enter Registration ID",
  EnterAddress:"Enter Address",
  EnterInformation:"Enter Information",
  EnterPortfolioName:"Enter Portfolio Name",
  EnterUserName:"Enter User",
  SelectTaskName:"Select Task",
  EnterNotes:"Enter Notes",
  OnlineMatching:"Online Matching",
  StartingMonth:"Starting Month",
  EndMonth:"End Month",
},
  ...deLocale
}

export default de